import { render, staticRenderFns } from "./Limiteds.vue?vue&type=template&id=79cce14c&scoped=true"
import script from "./Limiteds.vue?vue&type=script&lang=js"
export * from "./Limiteds.vue?vue&type=script&lang=js"
import style0 from "./Limiteds.vue?vue&type=style&index=0&id=79cce14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cce14c",
  null
  
)

export default component.exports